import { useEffect } from 'react';
import { useStore } from '../store.js';

/**
 * SPEC §2.7: Desktop (and Web) surfaces MUST read and respect the
 * `design:` block of the opened Remedy. For v0 we recognise:
 *
 *   palette    'petitgen-dark' (default) — no alternative palettes yet.
 *   density    'comfortable' (default) | 'compact'
 *   voice      rendered as text in the StatusBar; no UI-level effect.
 *
 * Unknown values are ignored (surfaced as-is per the spec's tolerance
 * for open-ended hints).
 */
export function useDesignBlock(): void {
  const doc = useStore((s) => s.doc);

  useEffect(() => {
    const body = document.body;
    const design = (doc?.design ?? {}) as Record<string, unknown>;

    const palette = typeof design.palette === 'string' ? design.palette : 'petitgen-dark';
    const density = typeof design.density === 'string' ? design.density : 'comfortable';

    body.dataset.palette = palette;
    body.dataset.density = density;

    return () => {
      delete body.dataset.palette;
      delete body.dataset.density;
    };
  }, [doc]);
}
